import * as signalR from "@microsoft/signalr";
// export default function Signalr(setSensorDataArray?: any) {
export default function WatchGPSHub(props: {
    sn?: string,
    setGPSData?: Function
}) {
    const {
        sn,
        setGPSData,
    } = props;
    //TODO
    let connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}watchGps`).build();
    connection.start().then(() => {
        // console.log("started", sn, "WatchGPSHub");
        connection.invoke("SubscribeToWatchGpsData", sn);
    }).catch((err: any) => {
        return console.error(err.toString());
    });

    connection.on("ReceiveSensorData", (data: any) => {
        // console.log("sn: " + sn + ", data: ", data);
        setGPSData && setGPSData([data]); // Update the data array or object

    });

    return () => {
        connection.stop();
    };
}